export const USER_CREATION_STATE = {
  IN_PROCESS: 'IN_PROCESS',
  COMPLETE: 'COMPLETE'
};